exports.handler = phoneNumberString => {
  if (!phoneNumberString) return '';
  if (/^\(\d{1,3}\) \d{1,3}-\d{1,4}$/.test(phoneNumberString)) return phoneNumberString;
  const onlyNums = phoneNumberString.replace(/[^\d]/g, '');
  if(onlyNums.length > 10) return phoneNumberString;
  return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`;
}